// SPDX-License-Identifier: BUSL-1.1

/**
 * Dashboard entry point — routes to V1 or V2 based on dashboard-v2 flag.
 *
 */

import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { DashboardV1 } from './dashboard-v1';
import { DashboardV2 } from './dashboard-v2';

export function DashboardPage() {
  const v2Enabled = useFeatureFlag('dashboard-v2');
  return v2Enabled ? <DashboardV2 /> : <DashboardV1 />;
}
